import {
  green, red, white, primaryMain, secondaryMain, grey, yellow,
} from 'now-frontend-shared/themes/colors';

export default {
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50px',
    width: '150px',
    margin: '10px 0',
    borderRadius: '8px',
    border: 'unset',
    outline: 'none',
    color: grey,
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 'bold',
    textAlign: 'center',
    textTransform: 'none',
    textDecoration: 'none',
    backgroundColor: 'inherit',
    boxShadow: 'unset',
    transition: 'all 0.25s ease-in-out',

    '&:hover': {
      backgroundColor: green,
      color: '#fff',
    },

    '@media screen and (max-width: 600px)': {
      width: '120px',
    },
  },
  white: {
    border: `2px solid ${white}`,
    color: white,

    '&:hover': {
      backgroundColor: primaryMain,
      border: 'unset',
    },
  },
  red: {
    border: `2px solid ${red}`,
    color: red,

    '&:hover': {
      backgroundColor: red,
    },
  },
  green: {
    color: white,
    backgroundColor: green,

    '&:hover': {
      backgroundColor: primaryMain,
    },
  },
  primaryMain: {
    color: white,
    backgroundColor: primaryMain,

    '&:hover': {
      backgroundColor: secondaryMain,
    },
  },
  secondaryMain: {
    color: white,
    backgroundColor: secondaryMain,

    '&:hover': {
      backgroundColor: primaryMain,
    },
  },
  redFilled: {
    color: white,
    backgroundColor: red,

    '&:hover': {
      backgroundColor: green,
    },
  },
  clearGreen: {
    color: green,
    backgroundColor: white,
    border: `2px solid ${green}`,

    '&:hover': {
      color: white,
      backgroundColor: green,
    },
  },
  inherit: {
    border: `2px solid ${grey}`,
  },
  disabled: {
    pointerEvents: 'none',
    userSelect: 'none',
    opacity: 0.5,
  },
  yellow: {
    color: white,
    backgroundColor: yellow,

    '&:hover': {
      backgroundColor: green,
    },
  },
  clearYellow: {
    color: yellow,
    backgroundColor: white,
    border: `2px solid ${yellow}`,

    '&:hover': {
      color: white,
      backgroundColor: yellow,
    },
  },
  clear: {
    background: 'transparent',
    border: 'solid 1px #fff',
    color: '#fff',
    width: 'inherit',
    padding: '10px 20px',
    '&:hover': {
      backgroundColor: primaryMain,
    },
  },

};
